module.exports = __webpack_public_path__ + "static/media/loader.75fe8013.svg";